import {
  HiOutlineChartPie,
  HiOutlineClipboard,
  HiOutlineClipboardCheck,
  HiOutlineCurrencyDollar,
  HiOutlineDocumentDuplicate,
  HiOutlineDocumentText,
  HiOutlineHome,
  HiOutlineShieldCheck,
  HiOutlineTruck,
  HiOutlineUser,
} from 'react-icons/hi'
import {
  HiHomeModern,
  HiOutlineCircleStack,
  HiOutlineCog6Tooth,
  HiOutlineReceiptPercent,
  HiOutlineSquare2Stack,
} from 'react-icons/hi2'

import { ENABLE_KLAIM_ASURANSI_V2, moduleName } from '@constants/index'

const navigation = [
  {
    title: 'Home',
    to: '',
    icon: HiOutlineHome,
    access: [moduleName.dashboard],
  },
  {
    title: 'Bagshiplink',
    to: '/shiplink',
    icon: HiOutlineClipboardCheck,
    access: [moduleName.shiplink],
  },
  {
    title: 'Dashboard',
    to: '/dashboard',
    icon: HiOutlineChartPie,
    children: [
      {
        title: 'Dashboard Penjualan',
        to: '/dashboard-penjualan',
        access: [moduleName.dashboardPenjualan],
      },
      {
        title: 'Dashboard Niaga',
        to: '/dashboard-niaga',
        access: [moduleName.dashboardNiaga],
      },
      {
        title: 'Dashboard Shipment Operasi BBO',
        to: '/dashboard-bbo',
        access: [moduleName.dashboardBBO],
      },
    ],
  },
  {
    title: 'User Management',
    to: '/users',
    icon: HiOutlineUser,
    access: [moduleName.userManagement],
  },
  {
    title: 'Kontrak',
    to: '/contract',
    icon: HiOutlineDocumentText,
    children: [
      {
        title: 'Kontrak KSO',
        to: '/kontrak-mitra-kso',
        access: [moduleName.kontrakMitraKSO],
      },
      {
        title: 'Pemberi Kerja',
        to: '/pemberi-kerja',
        access: [moduleName.kontrakPemberiKerja],
      },
      {
        title: 'Pemberi Kerja Pangkalan Susu',
        to: '/employer-pangsu',
        isNewModule: true,
        access: [moduleName.kontrakPemberiKerjaPangsu],
      },
      {
        title: 'Mitra Pangkalan Susu',
        to: '/mitra-pangsu',
        isNewModule: true,
        access: [moduleName.kontrakMitraPangsu],
      },
      {
        title: 'Pemberi Kerja Tanjung Jati B',
        to: '/employer-tjb',
        isNewModule: true,
        access: [moduleName.kontrakPemberiKerjaTJB],
      },
      {
        title: 'Mitra Tanjung Jati B',
        to: '/mitra-tjb',
        isNewModule: true,
        access: [moduleName.kontrakMitraTJB],
      },
      {
        title: 'Rapat Koordinasi Tanjung Jati B',
        to: '/coordination-meeting',
        isNewModule: true,
        access: [moduleName.coordinationMeetingTJB],
      },
    ],
  },

  // {
  //   title: 'Route Shipment',
  //   to: '/route-shipment',
  //   icon: HiOutlineGlobeEuropeAfrica,
  //   access: [moduleName.mdRouteShipment],
  // },
  {
    title: 'Shipment Order',
    to: '/shipment-order',
    icon: HiOutlineClipboard,
    access: ['shipment-order'],
    children: [
      {
        title: 'Shipment',
        to: '/shipment',
        access: [moduleName.shipment],
      },
      {
        title: 'Agenda Rakor',
        to: '/agenda-rakor',
        access: [moduleName.agendaRakor],
      },
      {
        title: 'Shipping Instruction',
        to: '/sailing-instruction',
        access: [moduleName.sailingInstruction],
      },
      {
        title: 'SPAL',
        to: '/spal',
        access: [moduleName.spal],
      },
    ],
  },
  {
    title: 'Operation',
    to: '/operation',
    icon: HiOutlineTruck,
    access: [moduleName.operation],
    children: [
      {
        title: 'Shipment Operation',
        to: '/shipment-operation',
        access: [moduleName.shipmentOperation],
      },
      {
        title: 'Arsip Shipment',
        to: '/arsip-operation',
        access: [moduleName.shipmentOperation],
      },
    ],
  },
  {
    title: 'Pangkalan Susu',
    to: '/pangkalan-susu',
    icon: HiHomeModern,
    children: [
      {
        title: 'Jadwal Shipment',
        to: '/shipment-schedule',
        isNewModule: true,
        access: [moduleName.jadwalShipmentPangsu],
      },
      {
        title: 'Operasi Pemeliharaan',
        to: '/operasi-pemeliharaan',
        isNewModule: true,
        access: [moduleName.operasiPemeliharaanPangsu],
      },
      {
        title: 'Operasi Shipment',
        to: '/shipment-operation',
        isNewModule: true,
        access: [moduleName.operasiShipmentPangsu],
      },
      {
        title: 'Penagihan',
        to: '/billing',
        isNewModule: true,
        access: [moduleName.penagihanPangsu],
      },
      {
        title: 'Pembayaran Mitra',
        to: '/shipment-payment',
        isNewModule: true,
        access: [moduleName.pembayaranPangsu],
      },
    ],
  },
  {
    title: 'Tanjung Jati B.',
    to: '/tanjung-jati-b',
    icon: HiOutlineDocumentText,
    children: [
      {
        title: 'Jadwal Shipment',
        to: '/shipment-planning',
        isNewModule: true,
        access: [moduleName.shipmentPlanningTJB],
      },
      {
        title: 'Shipment Operation',
        to: '/shipment-operation',
        isNewModule: true,
        access: [moduleName.shipmentOperationTJB],
      },
      {
        title: 'Penagihan Pemberi Kerja',
        to: '/invoice',
        isNewModule: true,
        access: [moduleName.customerInvoiceTJB],
      },
      {
        title: 'Pembayaran Mitra',
        to: '/payment',
        isNewModule: true,
        access: [moduleName.vendorBillTJB],
      },
    ],
  },
  {
    title: 'Asuransi',
    to: '/asuransi',
    icon: HiOutlineShieldCheck,
    access: [moduleName.asuransi],
    children: [
      {
        title: 'Klaim Asuransi MCI',
        to: '/klaim-asuransi',
        access: [moduleName.klaimAsuransi],
      },
      ...(ENABLE_KLAIM_ASURANSI_V2
        ? [
            {
              title: 'Klaim Asuransi V2 MCI',
              to: '/klaim-asuransi',
              isNewModule: true,
              access: [moduleName.klaimAsuransi],
            },
            {
              title: 'Proses Klaim Asuransi MCI',
              to: '/klaim-asuransi-workflow-v2',
              isNewModule: true,
              access: [moduleName.klaimAsuransi],
            },
            {
              title: 'Arsip Asuransi MCI',
              to: '/arsip-asuransi',
              isNewModule: true,
              access: [moduleName.arsipAsuransi],
            },
            {
              title: 'Arsip Asuransi Workflow V2 MCI',
              to: '/arsip-asuransi-workflow-v2',
              isNewModule: true,
              access: [moduleName.arsipAsuransi],
            },
          ]
        : []),
      {
        title: 'Daftar Asuransi MCI',
        to: '/list-insurance',
        access: [moduleName.listAsuransi],
      },
    ],
  },

  {
    title: 'Penagihan',
    to: '/penagihan',
    icon: HiOutlineReceiptPercent,
    access: [moduleName.penagihanMitraKso],
    // children: [
    //   {
    //     title: 'Operasi Mitra',
    //     to: '/mitra',
    //     access: [moduleName.penagihanMitraKso],
    //   },
    //   {
    //     title: 'Operasi Sendiri',
    //     to: '/pemberi-kerja',
    //     access: [moduleName.penagihanPemberiKerja],
    //   },
    // ],
  },
  {
    title: 'Pembayaran Mitra',
    to: '/pembayaran-mitra',
    icon: HiOutlineCurrencyDollar,
    access: [moduleName.pembayaranMitra],
  },
  // {
  //   title: 'Nota Dinas',
  //   to: '/nota-dinas',
  //   icon: HiOutlineSquare2Stack,
  //   access: [moduleName.notaDinasPenagihan],
  // },
  {
    title: 'Master Data',
    to: '/master-data',
    icon: HiOutlineCircleStack,
    children: [
      {
        title: 'Pemberi Kerja',
        to: '/md-pemberi-kerja',
        access: [moduleName.mdPemberiKerja],
      },
      {
        title: 'Mitra KSO',
        to: '/mitra-kso',
        access: [moduleName.mdMitraKso],
      },
      {
        title: 'Termin',
        to: '/termin',
        access: [moduleName.mdTermin],
      },
      {
        title: 'Pemasok',
        to: '/pemasok',
        access: [moduleName.mdPemasok],
      },
      {
        title: 'Moda',
        to: '/moda',
        access: [moduleName.mdModa],
      },
      {
        title: 'PoL',
        to: '/pol',
        access: [moduleName.mdPol],
      },
      {
        title: 'PoD',
        to: '/pod',
        access: [moduleName.mdPod],
      },
      {
        title: 'Kapal/Vessel',
        to: '/kapal-vessel',
        access: [moduleName.mdKapal],
      },
      {
        title: 'Route',
        to: '/route',
        access: [moduleName.mdRouteShipment],
      },
      {
        title: 'Formula',
        to: '/formula',
        access: [moduleName.mdFormula],
      },
      {
        title: 'Harga Triwulan',
        to: '/harga-triwulan',
        access: [moduleName.mdHargaTriwulan],
      },
      {
        title: 'Kapal Dredging',
        to: '/kapal-dredging',
        access: [moduleName.mdKapalDredging],
      },
      {
        title: 'Templates',
        to: '/templates',
        access: [moduleName.mdTemplate],
      },
      {
        title: 'Tanda Tangan',
        to: '/tanda-tangan',
        access: [moduleName.signature],
      },
      {
        title: 'Jetty',
        to: '/jetty',
        isNewModule: true,
        access: [moduleName.mdJetty],
      },
      {
        title: 'Jisdor',
        to: '/jisdor',
        isNewModule: true,
        access: [moduleName.mdJisdor],
      },
    ],
  },
  {
    title: 'BBM Berjalan',
    to: '/bbm',
    icon: HiOutlineSquare2Stack,
    access: [moduleName.bbmBerjalan],
  },
  {
    title: 'Pengaturan',
    to: '/settings',
    icon: HiOutlineCog6Tooth,
    access: ['setting'],
  },
  {
    title: 'Laporan',
    to: '/laporan',
    icon: HiOutlineDocumentDuplicate,
    children: [
      {
        title: 'Monitoring SLA Muat Bongkar',
        to: '/monitoring-sla',
        access: [moduleName.listSla],
      },
      {
        title: 'Pendapatan Angkutan BatuBara',
        to: '/pendapatan-batubara',
        access: [moduleName.pendapatanBatuBara],
      },
      {
        title: 'Rasio Biaya Operasional KSO',
        to: '/rasio-operasional-kso',
        access: [moduleName.rasioOperasionalKso],
      },
      {
        title: 'Shipment Tepat Waktu',
        to: '/shipment-tepat-waktu',
        access: [moduleName.shipmentTepatWaktu],
      },
      {
        title: 'Penerimaan Cash Operasional - Cash In',
        to: '/cash-in',
        access: [moduleName.laporanCashIn],
      },
      {
        title: 'Realisasi Pembayaran Operasional KSO - Cash Out',
        to: '/cash-out',
        access: [moduleName.laporanCashOut],
      },
      {
        title: 'Route Shipment Belum Bertarif',
        to: '/shipment-belum-bertarif',
        access: [moduleName.laporanShipmentBelumBertarif],
      },
      {
        title: 'Shipment To Be Nominated (TBN)',
        to: '/shipment-tbn',
        access: [moduleName.laporanShipmentTBN],
      },
      {
        title: 'Status Shipment per Mitra KSO',
        to: '/shipment-kso',
        access: [moduleName.laporanShipmentKSO],
      },
      {
        title: 'Kinerja Angkut Mitra KSO (Tonase BL)',
        to: '/tonase-bl',
        access: [moduleName.laporanTonaseBL],
      },
      {
        title: 'Idle Time Armada Harian Per Pemasok',
        to: '/idle-pemasok',
        access: [moduleName.laporanIdlePemasok],
      },
      {
        title: 'Pengangkutan Batubara Per Pemasok',
        to: '/pengangkutan-batubara',
        access: [moduleName.laporanPengangkutanBatubara],
      },
      {
        title: 'Shipment Per PLTU',
        to: '/shipment-pltu',
        access: [moduleName.laporanPengangkutanBatubara],
      },
      {
        title: 'Idle Time Armada Harian Per PLTU',
        to: '/idle-pltu',
        access: [moduleName.laporanIdlePltu],
      },
      {
        title: 'Kelengkapan Dokumen Shipment',
        to: '/kelengkapan-dokumen',
        access: [moduleName.laporanKelengkapanDokumen],
      },
    ],
  },
  {
    title: 'Kontrak Dredging',
    to: '/dredging-contract',
    icon: HiOutlineDocumentDuplicate,
    children: [
      {
        title: 'Pemberi Kerja',
        to: '/pemberi-kerja',
        access: [moduleName.dredgingContractPemberiKerja],
      },
      {
        title: 'Mitra KSO',
        to: '/mitra-kso',
        access: [moduleName.dredgingContractMitraKSO],
      },
    ],
  },
  {
    title: 'Dredging Operation',
    to: '/dredging-operation',
    icon: HiOutlineDocumentDuplicate,
    children: [
      {
        title: 'Planning',
        to: '/planning',
        access: [moduleName.dredgingOperationPlanning],
      },
      {
        title: 'Operation',
        to: '/operation',
        access: [moduleName.dredgingOperationOperation],
      },
    ],
  },
  {
    title: 'Penagihan Dredging',
    to: '/penagihan-dredging',
    icon: HiOutlineDocumentDuplicate,
    children: [
      {
        title: 'Pemberi Kerja',
        to: '/pemberi-kerja',
        access: [moduleName.dredgingBCPemberiKerja],
      },
      {
        title: 'Mitra',
        to: '/mitra',
        access: [moduleName.dredgingBCMitra],
      },
    ],
  },
]

export { navigation }
